// extracted by mini-css-extract-plugin
module.exports = {"mask":"spinner_mask__6UmBu","progress":"spinner_progress__3G3V5"};